import React from "react";

interface GoogleMapProps {
  className?: string;
}

export const GoogleMap: React.FC<GoogleMapProps> = ({ className = "" }) => {
  return (
    <div
      className={`bg-gradient-to-br from-blue-50 to-green-50 rounded-xl p-6 shadow-lg ${className}`}
    >
      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
        <span className="text-2xl mr-2">📍</span>
        Find Us Here
      </h3>

      <div className="relative w-full h-64 rounded-lg overflow-hidden shadow-md">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.1234567890!2d76.3457795!3d30.8166613!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39100726df24c193%3A0xa31a5429dc21f167!2sKhamanon%2C%20Punjab%20141801%2C%20India!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Benipal Toys & Gift Store Location"
        />
      </div>

      <div className="mt-4 flex justify-center">
        <a
          href="https://www.google.com/maps/dir//Khamanon,+Punjab+141801,+India/@30.8166352,76.2633782,25048m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x39100726df24c193:0xa31a5429dc21f167!2m2!1d76.3457795!2d30.8166613?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
        >
          <span className="text-lg mr-2">🚗</span>
          Get Directions
        </a>
      </div>
    </div>
  );
};

export default GoogleMap;
